import apolloClient from 'shared/apolloClient'
import { SaveProductSelectionMutation } from '../../../application/components/LoanAmount/mutations'
import { ProductAndSelectionQuery } from '../../../application/components/ProductListing/queries'
import { GLOBAL_PATHS, APPLICATION_PATHS } from 'constants/paths'
import { RESULT_CODES } from 'constants/values'
import { UpdateAutopay } from '../../../account/graphql/mutations'

/**
 * 
 * Product preference 
 */
export const processSasCall2Response = (sasResult, setAttemptStatus) => {
  switch (sasResult) {
    case RESULT_CODES.PROCEED_APPLICATION:
      window.location.href = GLOBAL_PATHS.APPLICATION
      break
    case RESULT_CODES.CARD_ERROR_1:
      setAttemptStatus(RESULT_CODES.CARD_ERROR_1)
      break
    case RESULT_CODES.CARD_ERROR_2:
      setAttemptStatus(RESULT_CODES.CARD_ERROR_2)
      break
    case RESULT_CODES.DECLINED:
      setAttemptStatus(RESULT_CODES.DECLINED)
      break
    case RESULT_CODES.NEEDS_NEW_REPAYMENT:
      setAttemptStatus(RESULT_CODES.NEEDS_NEW_REPAYMENT)
      break
    case RESULT_CODES.NEEDS_NEW_FUNDING:
      setAttemptStatus(RESULT_CODES.NEEDS_NEW_FUNDING)
      break
    default:
      setAttemptStatus(RESULT_CODES.CARD_ERROR_1)
      break
  }
}

export const handleSaveProductSelection = async (debitCardProduct, setAttemptStatus) => {
  const { data: { updateProductSelection: { sasResult } } } = await apolloClient.mutate({
    mutation: SaveProductSelectionMutation,
    variables: { productOffer: debitCardProduct },
    update: (cache, { data: { updateProductSelection } }) => {
      const {
        applicationId,
        applicationStatus,
        sasResult,
      } = updateProductSelection
      let applicationProductSelection = null
      let data = {}

      //DENIED by QFUND->SAS call2
      if (applicationStatus === 'DENIED') {
        window.location.href = APPLICATION_PATHS.ADVERSE_ACTION
      } else if (sasResult === RESULT_CODES.PROCEED_APPLICATION) {
        //REGULAR FLOW
        try {
          data =
            cache.readQuery({
              query: ProductAndSelectionQuery,
              variables: { applicationId },
            }) || {}
          applicationProductSelection =
            data.applicationProductSelection
        } catch (error) {
          applicationProductSelection = null
        }
        if (
          !applicationProductSelection ||
          !applicationProductSelection.id
        ) {
          cache.writeQuery({
            query: ProductAndSelectionQuery,
            variables: { applicationId },
            data: {
              ...data,
              applicationProductSelection: updateProductSelection,
            },
          })
        }
      }
    },
  })
  processSasCall2Response(sasResult, setAttemptStatus)

}

export const handleSaveProductIframeActions = (setAttemptStatus, setIsDisabled, setNewRepayment, closeModal, attemptStatus) => {
  if (
    attemptStatus === RESULT_CODES.CARD_ERROR_1 ||
    attemptStatus === RESULT_CODES.CARD_ERROR_2 ||
    attemptStatus === RESULT_CODES.ERROR_IFRAME
  ) {
    setAttemptStatus(undefined)
    setTimeout(() => {
      setIsDisabled(false)
    }, 2000)
  }
  if (
    attemptStatus === RESULT_CODES.NEEDS_NEW_REPAYMENT ||
    attemptStatus === RESULT_CODES.NEEDS_NEW_FUNDING
  ) {
    closeModal()
    setNewRepayment(true)
    setTimeout(() => {
      setIsDisabled(false)
    }, 2000)
  }

}

/**
 * 
 * Manage autopay 
 * 
 */
export const handleSaveAutopay = async (loanNumber, autoPayChangeMode, request, setAttemptStatus) => {
  const { data: { updateLoanAutopay: { status } } } = await apolloClient.mutate({
    mutation: UpdateAutopay,
    variables: {
      autopayUpdateRequest: {
        loanNumber,
        autoPayChangeMode,
        ...request
      }
    }
  })

  setAttemptStatus(status)
}

export const handleManageAutopayIframeActions = (attemptStatus, setAttemptStatus, setIsDisabled) => {
  if (attemptStatus === 'FAILED') {
    setTimeout(() => {
      setIsDisabled(false)
    }, 2000)
  } else if (attemptStatus === 'RETRY') {
    setAttemptStatus(undefined)
    setTimeout(() => {
      setIsDisabled(false)
    }, 2000)
  }
}

/**
 * 
 * debit card mapping
 */
export const mapCardVerifyResponse = (paylianceActionsResults) => {
  return {
    network: paylianceActionsResults.network,
    networkResponse: paylianceActionsResults.networkResponse,
    transactionStatus: paylianceActionsResults.transactionStatus,
    approvalCode: paylianceActionsResults.approvalCode,
    avsResponse: paylianceActionsResults.avsResponse,
    securityResponse: paylianceActionsResults.securityResponse,
    issuer: paylianceActionsResults.issuer,
    verifyType: paylianceActionsResults.verifyType,
    verifyFund: paylianceActionsResults.verifyFund,
    verifySale: paylianceActionsResults.verifySale,
    category: paylianceActionsResults.category,
    country: paylianceActionsResults.country,
    blocked: paylianceActionsResults.blocked,
    successful: paylianceActionsResults.successful,
    message: paylianceActionsResults.message,
    ani: paylianceActionsResults.ani || paylianceActionsResults.ANI,
    fullName: paylianceActionsResults.fullName,
    firstName: paylianceActionsResults.firstName,
    lastName: paylianceActionsResults.lastName
  }
}
